import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import Journal from '../list/journal';

const API_PATH = 'event-poll-journals';
const API_PATH_FAKE = 'poll-journals/fake';

export const JournalManager = {
  objects: objectsRHandler(API_PATH, Journal),
  // у журналов поиск фейковых(внешних) по is_fake_poll или is_poll_fake
  fake: objectsRHandler(API_PATH_FAKE, Journal),

  answer: {
    create({ args, data, obs } = DEFAULT_PARAMS) {
      const [journalId, questionId] = args;
      return rHandler(
        apiService.post(`${API_PATH}/${journalId}/answer/${questionId}`, data),
        (response) => response,
        (error) => ({ error }),
        obs,
      );
    },
    update({ args, data, obs } = DEFAULT_PARAMS) {
      const [journalId, questionId, id] = args;
      return rHandler(
        apiService.put(`${API_PATH}/${journalId}/answer/${questionId}/${id}`, data),
        (response) => response,
        (error) => ({ error }),
        obs,
      );
    },
  },

  finish({ args, data } = DEFAULT_PARAMS) {
    const [id] = args;
    return rHandler(
      apiService.post(`${API_PATH}/${id}/finish`, data),
      (response) => response,
      (error) => ({ error }),
    );
  },

  expertises({ params } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.get(`${API_PATH}/expertises`, params),
      (response) => ({
        response,
        items: response.data.data.map((i) => new Journal(i, `${API_PATH}/expertises`)),
      }),
      (error) => ({ error }),
    );
  },
};
